"use client"

export default function Error() {
  return (
    <div className="relative h-0 flex-grow">
      <div className="flex h-full w-full items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <h1 className="text-2xl font-bold">Something went wrong</h1>
          <p className="text-gray-500">Please try again later.</p>
        </div>
      </div>
    </div>
  )
}
